angular.module('jv.Admin.Users.Employee.Service',[
        'jv.Admin.Users.URLs.Factory',
        'jv.Admin.Users.Ajax.Factory',
        'jv.Admin.Users.PostParams.Factory',
        'jv.Admin.Users.EmployeeSelect.Factory'
    ])
    .service('adminUserSVC', function(prepareAjaxCall, jvAdminUsersUrls, employeeSelectFAC, postParamsFAC, $window) {

        this.getReqsList = function(params, callback, fail) {
            var options = {
                'ajaxtype': 'requisitionListofEmployee',
                'url': jvAdminUsersUrls.requisitionListofEmployee  + params,
            };
            prepareAjaxCall({}, options, callback, fail);
        };
        
        this.getEmployeeListDetails = function(callback, fail) {
            var options = {
                'ajaxtype': 'employeeListDetails',
                'url': jvAdminUsersUrls.employeeListDetails,
            };
            function transformRequest(response) {
                if(response && response.filters && response.filters.inviteStatus) {
                    response.filters.inviteStatus = postParamsFAC.transformInvite(response.filters.inviteStatus);
                }
                callback(response);
            }
            prepareAjaxCall({}, options, transformRequest, fail);
        };

        this.searchEmployees = function(params, callback, readMode, fail) {
            var args = postParamsFAC.serializeObject(params);
            if(readMode){
                args.push({
                    name: 'readMode',
                    value: 0
                });
            }
            var options = {
                'ajaxtype': 'employeeSearchResults',
                'url': jvAdminUsersUrls.employeeSearch + $.param(args),
            };
            prepareAjaxCall({}, options, callback, fail);
        };

        this.employeeSelect = employeeSelectFAC;

        this.getEmployeeDetails = function (userEId, callback, fail, readMode) {
            var url = postParamsFAC.formatURL(jvAdminUsersUrls.getEmployeeDetailsByEId, userEId);
            if(readMode) {
                url += '&readMode=0';
            }
            var options = {
                'ajaxtype': 'requisitionListofEmployee',
                'url': url,
            };
            prepareAjaxCall({}, options, callback, fail);
        };

        this.getEmployeePagination = function(data, callback, fail){
            var options = {
                'ajaxtype': 'requisitionListofEmployee',
                'url': (jvAdminUsersUrls.employeePaginationList + data),
            };
            prepareAjaxCall({}, options, callback, fail);
        };

        this.getInviteTemplates = function(callback, fail) {
            var options = {
                'ajaxtype': 'sendInviteTemplateList',
                'url': jvAdminUsersUrls.sendInviteTemplateList
            };
            prepareAjaxCall({}, options, callback, fail);
        };

        this.getNoteTemplates = function(callback, fail) {
            var options = {
                'ajaxtype': 'getEmployeeNoteTemplateList',
                'url': jvAdminUsersUrls.getEmployeeNoteTemplate
            };
            prepareAjaxCall({}, options, callback, fail);
        };

        this.updateRoles = function(data, callback, fail) {
            var args = postParamsFAC.serializeObject(data);
            var options = {
                'ajaxtype': 'employeeUpdateRole',
                'url': jvAdminUsersUrls.employeeUpdateRole,
                'requestType': 'POST',
                'headerType': 'form'
            };
            prepareAjaxCall(args, options, callback, fail);
        };
        
        
        this.addSuperUserRole = function(email, callback, fail) {
            var url = postParamsFAC.formatURL(jvAdminUsersUrls.employeeAddSuperUserRole, email);
            var options = {
                'ajaxtype': 'addSuperUserRole',
                'url': url
            };
            prepareAjaxCall({}, options, callback, fail);
        };

        this.saveEmployeeNote = function(data, callback, fail){
            var args = postParamsFAC.serializeObject(data);
            var options = {
                'ajaxtype': 'sendEmployeeNote',
                'url': jvAdminUsersUrls.sendEmployeeNote,
                'requestType': 'POST',
                'headerType': 'form'
            };
            prepareAjaxCall(args, options, callback, fail);
        };

        this.sendEmployeeInvite = function(data, callback, fail){
            var args = postParamsFAC.serializeObject(data);
            var options = {
                'ajaxtype': 'sendEmployeeInvite',
                'url': jvAdminUsersUrls.sendEmployeeInvite,
                'requestType': 'POST',
                'headerType': 'form'
            };
            prepareAjaxCall(args, options, callback, fail);
        };

        this.lockRecords = function(data, callback, fail){
            var args = postParamsFAC.serializeObject(data);
            var options = {
                'ajaxtype': 'setEmployeeLockUnlock',
                'url': jvAdminUsersUrls.setEmployeeLockUnlock,
                'requestType': 'POST',
                'headerType': 'form'
            };
            prepareAjaxCall(args, options, callback, fail);
        };

        this.removeEmployee = function(data, callback, fail){
            var args = postParamsFAC.serializeObject(data);
            var options = {
                'ajaxtype': 'removeEmployees',
                'url': jvAdminUsersUrls.removeEmployees,
                'requestType': 'POST',
                'headerType': 'form'
            };
            prepareAjaxCall(args, options, callback, fail);
        };

        this.getMessageTemplates = function(callback, fail) {
            var options = {
                'ajaxtype': 'getMessageTemplateList',
                'url': jvAdminUsersUrls.getMessageTemplateList
            };
            prepareAjaxCall({}, options, callback, fail);
        };

        this.sendEmployeeMessage = function(data, callback, fail) {
            var args = postParamsFAC.serializeObject(data);
            var options = {
                'ajaxtype': '',
                'url': jvAdminUsersUrls.postEmployeeMessage,
                'requestType': 'POST',
                'headerType': 'form'
            };
            prepareAjaxCall(args, options, callback, fail);
        };

        this.getEmployeeAddEditFields = function (data, callback, fail) {
            var options = {};
            if(data.employeeId) {
                options = {
                    'ajaxtype': 'employeeEditByEIdDetails',
                    'url': postParamsFAC.formatURL(jvAdminUsersUrls.employeeEditByEIdData, data.employeeId)
                };
            } else {
                options = {
                    'ajaxtype': 'employeeAddNewForm',
                    'url': jvAdminUsersUrls.employeeAddNewFormData
                };
            }
            if(data.readMode) {
                options.url += '&readMode=0';
            }
            prepareAjaxCall({}, options, callback, fail);
        };

        this.saveEmployee = function(data, config, callback, fail) {
            var args = JSON.parse(JSON.stringify(data));
            var options = {};
            var customFields = {};
            Object.keys(args).forEach(key => {
                const fixedKeys = ["Employee", "CheckBox", "MultiSelect", "subject", "content"];
                if (fixedKeys.indexOf(key) == -1) {
                    if (Array.isArray(args[key])) {
                        customFields[key] = args[key];
                    } else {
                        customFields[key] = [args[key]];
                    }
                    delete args[key];
                }
            });
            args.customField = customFields;
            if (config.id) {
                options = {
                    'ajaxtype': 'employeeUpdateByEId',
                    'url': postParamsFAC.formatURL(jvAdminUsersUrls.employeeEditByEIdData, config.id),
                    'requestType': 'POST',
                    'headerType': 'json'
                };
            } else {
                options = {
                    'ajaxtype': 'employeeAddNew',
                    'url': jvAdminUsersUrls.employeeAddNewFormData,
                    'requestType': 'PUT',
                    'headerType': 'json'
                };
            }
            prepareAjaxCall(args, options, callback, fail);
        };

        this.sendInviteToAll = function(data, callback, fail){
            var args = postParamsFAC.serializeObject(data);
            var options = {
                'ajaxtype': 'sendAllEmployeeInvite',
                'url': jvAdminUsersUrls.sendAllEmployeeInvite,
                'requestType': 'POST',
                'headerType': 'form'
            };
            prepareAjaxCall(args, options, callback, fail);
        };

        this.getEmployeeAdditionalInfo = function(userEId, callback, fail) {
            var url = postParamsFAC.formatURL(jvAdminUsersUrls.getEmployeeAdditionalInfo, userEId);
            var options = {
                'ajaxtype': 'getEmployeeAdditionalInfo',
                'url': url
            };
            prepareAjaxCall({}, options, callback, fail);
        };
        
        this.import = function(key, fileName, sendInviteEmail, fullSync, resetSync, considerExclusionList, fileDelimiter, callback, fail) {
//        	var args = {"key":"/2016/05/12/04/company/1/admin/sync/employee/request/employee.csv"};
//        	args.url = jvUrls.admin + '/action/users/datasync/employees/import';
//        	args.type = 'POST';
//        	args.success = function(result) {
//        		alert(result);
//        	}
//        	$.ajax(args);
        	
        	 var args = {
        			 "key": key,
        			 "fileName": fileName,
        			 "sendInviteEmail": sendInviteEmail,
        			 "fullSync": fullSync,
        			 "resetSync": resetSync,
        			 "considerExclusionList": considerExclusionList,
        			 "fileDelimiter": fileDelimiter
        			 };
             var options = {
                 'ajaxtype': 'importEmployeeSyncFile',
                 'url': jvUrls.admin + '/action/users/datasync/employees/import',
                 'requestType': 'POST'
             };
             prepareAjaxCall(args, options, callback, fail);
        };
        
        this.submit = function(response, callback, fail) {
        	var args = response;
        	var options = {
                    'ajaxtype': 'submitMapping',
                    'headerType':'json',
                    'url': jvUrls.admin + '/action/users/datasync/employees/saveColumnMapping',
                    'requestType': 'POST'
                };
        	prepareAjaxCall(args, options, callback, fail);
        };
        
        this.updateMapping = function(response, callback, fail) {
        	var args = response;
        	var options = {
                    'ajaxtype': 'updateMapping',
                    'headerType':'json',
                    'url': jvUrls.admin + '/action/users/datasync/employees/saveColumnMapping/'+response.columnMappingId,
                    'requestType': 'PUT'
                };
        	prepareAjaxCall(args, options, callback, fail);
        };
        
        this.sftpImport = function(args, callback, fail) {
             var options = {
                 'ajaxtype': 'importSFTPEmployeeSyncFile',
                 'url': jvUrls.admin + '/action/users/datasync/employees/sftp/import',
                 'requestType': 'POST'
             };
             prepareAjaxCall(args, options, callback, fail);
        };
        
        this.getSftpLogs = function(args, callback, fail) {
        	var url = jvUrls.admin + '/action/users/datasync/employees/sftp/logs';
            var options = {
                'ajaxtype': 'getEmployeeSyncSftpLogs',
                'url': url
            };
            prepareAjaxCall({}, options, callback, fail);
        };
        
        this.getLogs = function(args, callback, fail) {
        	args.page = args.page ? args.page : 0;
        	args.pageSize = 0;
        	var url = jvUrls.admin + '/action/users/datasync/employees/logs/'+args.page+'/'+args.pageSize;
        	if (args.status || args.from || args.to) {
        		url += "?";
        	}
        	if (args.status) {
        		url += "status=" + args.status + "&";
        	}
        	
        	if (args.from) {
        		url += "fromCompletionDate=" + args.from + "&";
        	}
        	if (args.from) {
        		url += "toCompletionDate=" + args.to
        	}
            var options = {
                'ajaxtype': 'getEmployeeSyncLogs',
                'url': url
            };
            prepareAjaxCall({}, options, callback, fail);
        };
        
        this.getColumnMapping = function(args, callback, fail) {
        	var url = jvUrls.admin +'/action/users/datasync/employees/getColumnMappingSettings';
            var options = {
                'ajaxtype': 'getColumnMapping',
                'url': url
            };
            prepareAjaxCall({}, options, callback, fail);
        };
        
        this.getSelect2MappingValues = function(args, callback, fail) {
        	var delimiter = "Comma";
        	if(args.fileDelimiter === '\\t'){
        		delimiter = "Tab";
        	}
        	var url = jvUrls.admin + '/action/users/datasync/employees/sampleData?s3Key='+ args.uploadedFile.employeeSyncKey + '&fileDelimiter=' + delimiter;
            var options = {
                'ajaxtype': 'getSelect2MappingValues',
                'url': url
            };
            prepareAjaxCall({}, options, callback, fail);
        };
        
        this.getTimeZones = function(args, callback, fail) {
        	var url = jvUrls.admin + '/action/users/datasync/employees/timeZones';
            var options = {
                'ajaxtype': 'getTimezones',
                'url': url
            };
            prepareAjaxCall({}, options, callback, fail);
        };
        
        this.downloadTemplate = function() {
        	var url = jvUrls.admin +'/action/users/datasync/employees/download/template';
        	$window.location = url;
        };
        
        this.downloadEmployeeSyncFile = function(url) {
        	//$window.location = jvUrls.admin + '/action/users/datasync/employees/download/57557bc1fbe3161795f73359/SUMMARY';
        	$window.location = url;
        };
        this.saveDeleteThreshold = function(args, callback, fail) {
            var options = {
                'ajaxtype': 'deleteThreshold',
                'url': jvUrls.admin + '/action/users/datasync/employees/saveDeleteThreshold',
                'requestType': 'POST'
            };
            prepareAjaxCall(args, options, callback, fail);
       };
      this.getDeleteThresholdPercentage = function(args, callback, fail) {
      	var url = jvUrls.admin +'/action/users/datasync/employees/getDeleteThreshold';
          var options = {
              'ajaxtype': 'getDeleteThreshold',
              'url': url
          };
          prepareAjaxCall({}, options, callback, fail);
      };
      this.getJobExecutionDetails = function(args, callback, fail) {
      	var url = jvUrls.admin +'/action/users/datasync/employees/loadEmployeeSyncStatus/'+args.jobExecutionId;
          var options = {
              'ajaxtype': 'getJobExecutionDetails',
              'url': url
          };
          prepareAjaxCall({}, options, callback, fail);
      };
      this.submitPausedJobForSync = function(args, callback, fail) {
          var options = {
              'ajaxtype': 'submitPausedJobForSync',
              'url': jvUrls.admin + '/action/users/datasync/employees/executeActionOnPausedSync',
              'requestType': 'POST'
          };
          prepareAjaxCall(args, options, callback, fail);
     };
     this.cancelJobState = function(args, callback, fail) {
         var options = {
             'ajaxtype': 'cancelJobState',
             'url': jvUrls.admin + '/action/users/datasync/employees/executeActionOnPausedSync',
             'requestType': 'POST'
         };
         prepareAjaxCall(args, options, callback, fail);
    };

    })
.service('jvTimezones', [
    '$q', '$timeout', 'adminUserSVC',
    function($q, $timeout, adminUserSVC) {
        var timezones;
        this.getTimezones = function() {
            var deferred = $q.defer();
            if (!timezones) {
                adminUserSVC.getTimeZones(null, function(data) {
                    timezones = data.resultList;
                    deferred.resolve(timezones);
                }, function() {
                    deferred.reject();
                });
            }
            else {
                deferred.resolve(timezones);
            }
            return deferred.promise;
        }
    }
]);